export default __webpack_public_path__ + "static/media/diagnostics-icon.572a3e20.svg";